<template>
  <div :key="tagsKey">
    <div
      class="z-[10] fixed bottom-[70px] right-[40px] rounded-full flex justify-center [&_*]:duration-300"
    >
      <AppDataProperty
        contentId="addresses"
        @dataAvailable="
          data => {
            appData = data
          }
        "
        isComponent
      />

      <div
        class="absolute w-[70px] bottom-0 rounded-full flex flex-col pb-[60px] justify-center gap-6 items-center overflow-hidden"
        :class="{ 'h-[250px]': expandFab, 'h-[0] ': !expandFab }"
      >
        <div class="delay-[400ms]" :class="{ 'opacity-0': !expandFab }">
          <div
            @click="launchRating"
            rel="noopener noreferrer"
            class="flex items-center flex-col gap-2"
          >
            <div
              class="glassBg ripple w-16 h-16 rounded-full p-4 delay-[500ms]"
              :class="{ 'scale-[0.5]': !expandFab }"
            >
              <img
                src="@/assets/images/all/star-white.svg"
                class="w-full h-full saturate-0"
                alt=""
              />
            </div>
            <div class="text-sm">
              {{ $t('help.ratingIconText') }}
            </div>
          </div>
        </div>
        <div class="delay-[200ms]" :class="{ 'opacity-0': !expandFab }">
          <button
            @click="onAssistanceClick"
            class="flex items-center flex-col gap-2"
          >
            <div
              class="glassBg ripple w-16 h-16 rounded-full p-4 delay-[300ms]"
              :class="{ 'scale-[0.5]': !expandFab }"
            >
              <img
                src="@/assets/images/all/help-white.svg"
                class="w-full h-full"
                alt=""
              />
            </div>
            <div class="text-sm">
              {{ $t('help.chatIconText') }}
            </div>
          </button>
        </div>
        <div
          class="delay-[200ms]"
          :class="{ 'opacity-0': !expandFab }"
          v-if="false"
        >
          <button
            @click="onComplainClick"
            class="flex items-center flex-col gap-2"
          >
            <div
              class="glassBg ripple w-16 h-16 rounded-full p-4 delay-[300ms]"
              :class="{ 'scale-[0.5]': !expandFab }"
            >
              <img
                src="@/assets/images/all/help-white.svg"
                class="w-full h-full"
                alt=""
              />
            </div>
            <div class="text-sm">
              {{ $t('help.complainIconText') }}
            </div>
          </button>
        </div>
      </div>
      <div
        @click="expandFab = !expandFab"
        class="w-[60px] h-[60px] ripple glassBg rounded-full absolute bottom-0 p-7"
      >
        <img
          src="@/assets/images/all/info-white.svg"
          class="w-full h-full"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import AppDataProperty from '../appData/AppDataProperty.vue'

export default defineComponent({
  name: 'HomeBottomNavs',
  components: { AppDataProperty },
  props: {},
  data() {
    return {
      appData: {},
      expandFab: false,
      tagsKey: 'initial',
    }
  },
  mounted() {
    const id = this.$Events.handleEvent('lang_changed', () => {
      this.tagsKey = Date.now()
    })
  },
  methods: {
    launchRating() {
      this.$Events.dispatchEvent('start_rating')
      this.expandFab = false
    },
    onAssistanceClick() {
      this.expandFab = false
      this.$Events.dispatchEvent('open_chat')
    },
    onComplainClick() {
      this.expandFab = false
      this.$Events.dispatchEvent('open_chat')
    },
  },
  watch: {},
})
</script>
